import React, { Component } from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import styled from "styled-components";

import { State } from "src/state/ducks";
import * as OrderBreadActions from "src/state/ducks/orderBread/actions";

import StyleConfig from "src/constants/StyleConfig";
import { DefaultPageProps, HistoryProps } from "src/constants/Interface";

import { DefaultLayout } from "src/components/layouts/DefaultLayout";
import Heading from "src/components/atoms/typo/Heading";
import HomeButton from "src/components/atoms/button/HomeButton";
import SpinnerModal from "src/components/organisms/loading/SpinnerModal";
import DatePickerForm from "src/components/organisms/form/DatePickerForm";
import dayjs from "dayjs";

type OwnProps = {
  id: string;
};

type Props = DefaultPageProps &
  HistoryProps &
  OwnProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class OrderHistoryPage extends Component<Props> {
  componentDidMount() {
    this.props.getOrderBreads(this.props.login_shop_id);
  }

  getOrderdDaysArray() {
    return this.props.items.map((_) => {
      return dayjs(_.created_at.toDate()).format("YYYY-MM-DD");
    });
  }

  render() {
    const orderDays = this.getOrderdDaysArray();
    return (
      <DefaultLayout {...this.props}>
        <SpinnerModal isLoading={this.props.isFetching} />
        <Container>
          <Heading tag="h1" text="配信と注文状況を確認する" />
          <p className="lead">
            注文を確認したい日付を選択してください
            <br />
            ※灰色の日は焼き上がりの通知を行っていません
          </p>
          <div className="item">
            <DatePickerForm
              nextBaseUrl={`/shop/${this.props.id}/order_history/detail`}
              selectableDays={orderDays}
            />
          </div>
          <div className="item">
            <HomeButton />
          </div>
        </Container>
      </DefaultLayout>
    );
  }
}

const Container = styled.div`
  box-sizing: border-box;
  padding: ${StyleConfig.HELPER.M20};
  > .lead {
    font-size: 12px;
  }
  > .item {
    margin: ${StyleConfig.HELPER.M24} auto;
  }
`;

const mapStateToProps = (state: State) => ({
  items: state.orderBread.resource.map((bread) => {
    return {
      id: bread.id,
      is_notified: bread.is_notified,
      created_at: bread.created_at,
    };
  }),
  isFetching: state.bakedBread.isFetching,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getOrderBreads: (id: string) =>
    dispatch(OrderBreadActions.getOrderBreads({ shopId: id })),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderHistoryPage);
